import { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";

// Every grant on a session comes from evaluating the login policy at login, whether the policy
// named a role outright or the role was synthesized from a space access level. That makes the
// SessionGrantOrigin split an evaluation detail rather than a distinct origin, so the column reads
// the same for every row and needs nothing from the binding.
const ORIGIN_LABEL = "Evaluated login policy";

const SpaceDetailsAccessOriginCell = (cellProps: TableCellContentProps) => (
  <TableSimpleCell {...cellProps}>
    <TableCellText>{ORIGIN_LABEL}</TableCellText>
  </TableSimpleCell>
);

export default SpaceDetailsAccessOriginCell;
